import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { buildDxFilters, FillFilters, FormatPhoneNumber, loadLookupFromDataSource, loadLookupFromStaticDataSource } from '../../../../common/Utils'
import { useSearchState } from '../../../../common/SearchStatePersistence';
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { TransactionStatuses } from '../../../../const/Lookup';
import { OM } from '../../../../const/constants';

// DevExtreme numeric formats for this grid's columns, matched to the column types on
// TransactionHeaderModel so every numeric column renders with its real scale instead of
// the raw value. Declared once here rather than repeated inline on each column.
// Whole numbers (int on the DTO): no decimals and no thousands separator, so a
// fiscal year reads "2026" rather than "2,026".
const INTEGER_FORMAT = { type: 'fixedPoint', precision: 0, useGrouping: false };
// Quantities, amounts and percentages (double/decimal on the DTO) - two decimals.
const DECIMAL_FORMAT = { type: 'fixedPoint', precision: 2, useGrouping: true };
// Conversion factors and per-unit rates (decimal(29,10) in OMTRANSACTIONHEADER) - two
// decimals would round a rate away, so these keep four.
const RATE_FORMAT = { type: 'fixedPoint', precision: 4, useGrouping: true };

// Every date column on OMTRANSACTIONHEADER is a SQL `datetime`, so the columns declare
// dataType="datetime" and control what the user sees through these formats - the bound
// value keeps its time component, so filtering and sorting stay faithful to the column.

// Genuine timestamps (audit stamps, truck arrival/depart) show the time as well.
const DATETIME_FORMAT = "MM/dd/yyyy hh:mm:ss a";

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

// Identifies this listing's remembered search. Must stay unique across the app.
const SEARCH_STATE_PAGE_KEY = "om.salesOrderDataEntry";

// The search is remembered for a round trip into the Add/Edit form. Reaching the listing from
// anywhere else starts clean.
const SEARCH_STATE_DETAIL_PATHS = [
    "/om/transactions/salesorders/add-salesorder",
    "/om/transactions/salesorders/edit-salesorder",
];


const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "23208720-9C0E-4EB3-BFB0-3AF271CD975A";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        Module:OM,
        CREATIONUSERID: null,
        LASTUPDATEUSERID: null,
        TRANSACTIONTYPE: null,
        TRANSACTIONNUMBER: null,
        TRANSACTIONDATE: null,
        INVOICEDATE: null,
        TRANSACTIONDUEDATE: null,
        PURCHASEORDERNUMBER: null,
        PRICELEVEL: null,
        StatusFlag:null,
        IsOpenStatus: true,
        PICKSTATUS: null,
        DISCOUNTTYPE: null,
        ORDERSIGNEDFLAG: null,
        REFERENCE: null,
        COMMENT: null,
        SHIPPINGDATE: null,
        SHIPPERCOMMENT: null,
        TRUCKREFERENCE: null,
        TRUCKARRIVALDATETIME: null,
        TRUCKDEPARTDATETIME: null,
        TRUCKCOMMENT: null,
        PRINTINVOICE: null,
        PRINTBOL: null,
        PRINTDELIVERYNOTIFICATION: null,
        PRINTORDERACKNOWLEDGEMENT: null,
        SENDFAX: null,
        SENDEMAIL: null,
        CANCELDATE: null,
        CANCELCOMMENT: null,
        INVENTOTYAVAILABILITYSTATUS: null,
        USERDEFINEDCODE_1: null,
        USERDEFINEDCODE_2: null,
        USERDEFINEDCODE_3: null,
        USERDEFINEDCODE_4: null,
        USERDEFINEDCODE_5: null,
        USERDEFINEDCODE_6: null,
        USERDEFINEDCODE_7: null,
        USERDEFINEDCODE_8: null,
        USERDEFINEDCODE_9: null,
        USERDEFINEDCODE_10: null,
        USERDEFINEDREFERENCE_1: null,
        USERDEFINEDREFERENCE_2: null,
        USERDEFINEDREFERENCE_3: null,
        USERDEFINEDREFERENCE_4: null,
        USERDEFINEDREFERENCE_5: null,
        USERDEFINEDREFERENCE_6: null,
        USERDEFINEDREFERENCE_7: null,
        USERDEFINEDREFERENCE_8: null,
        USERDEFINEDREFERENCE_9: null,
        USERDEFINEDREFERENCE_10: null,
        USERDEFINEDDATE_1: null,
        USERDEFINEDDATE_2: null,
        USERDEFINEDDATE_3: null,
        USERDEFINEDDATE_4: null,
        USERDEFINEDDATE_5: null,
        USERDEFINEDDATE_6: null,
        USERDEFINEDDATE_7: null,
        USERDEFINEDDATE_8: null,
        USERDEFINEDDATE_9: null,
        USERDEFINEDDATE_10: null,
        USERDEFINEDQUANTITY_1: null,
        USERDEFINEDQUANTITY_2: null,
        USERDEFINEDQUANTITY_3: null,
        USERDEFINEDQUANTITY_4: null,
        USERDEFINEDQUANTITY_5: null,
        USERDEFINEDQUANTITY_6: null,
        USERDEFINEDQUANTITY_7: null,
        USERDEFINEDQUANTITY_8: null,
        USERDEFINEDQUANTITY_9: null,
        USERDEFINEDQUANTITY_10: null,
        USERDEFINEDCOMMENT: null,
        DISCOUNTPERCENT: null,
        PARTIALSHIPMENT: null,
        CREDITREVIEWDATE: null,
        CREDITREVIEWCOMMENT: null,
        SALESMETHOD: null,
        REASONCODE: null,
        FISCALPERIOD: null,
        FISCALYEAR: null,
        COMMITDATE: null,
        SALESCOMMISIONADVANCE: null,
        PRINTPICKINGSLIP: null,
        PRINTPACKINGSLIP: null,
        FMTRIPNUMBER: null,
        FMPUSTOPNUMBER: null,
        COMMISSIONTYPE: null,
        COMMISSIONTRANSACTIONPAYGROUP: null,
        COMMISSIONSETTLEMENTGROUP: null,
        FMTRANSFERFLAG: null,
        CURRENCYBASIS: null,
        CURRENCYCONVERSIONFACTOR: null,
        CURRENCYCONVERSIONDATE: null,
        StageFlag: null,
        BACKORDERFLAG: null,
        TRANSACTIONSUBTYPE: null,
        EDITRANSMITFLAG: null,
        TRANSACTIONORIGIN: null,
        COMMITTYPE: null,
        CURRENCYRATE: null,
        TRANSCURRENCYTYPE: null,
        PAYCURRENCYTYPE: null,
        RATETIMING: null,
        FMTRUCKREFERENCE: null,
        FMDRIVERREFERENCE: null,
        FMTRAILERREFERENCE: null,
        IMPORTFILENAME: null,
        DEFAULTDETAILDISCOUNT: null,
        CONSIGNMENT: null,
        EQUIPMENT: null,
        DEFAULTFREIGHTRATE: null,
        MISCFEETYPE: null,
        CHARGEANDHOLDTYPE: null,
        USERDEFINEDCODE_11: null,
        USERDEFINEDCODE_12: null,
        USERDEFINEDCODE_13: null,
        USERDEFINEDCODE_14: null,
        USERDEFINEDCODE_15: null,
        USERDEFINEDCODE_16: null,
        USERDEFINEDCODE_17: null,
        USERDEFINEDCODE_18: null,
        USERDEFINEDCODE_19: null,
        USERDEFINEDCODE_20: null,
        USERDEFINEDDATE_11: null,
        USERDEFINEDDATE_12: null,
        USERDEFINEDDATE_13: null,
        USERDEFINEDDATE_14: null,
        USERDEFINEDDATE_15: null,
        USERDEFINEDDATE_16: null,
        USERDEFINEDDATE_17: null,
        USERDEFINEDDATE_18: null,
        USERDEFINEDDATE_19: null,
        USERDEFINEDDATE_20: null,
        USERDEFINEDQUANTITY_11: null,
        USERDEFINEDQUANTITY_12: null,
        USERDEFINEDQUANTITY_13: null,
        USERDEFINEDQUANTITY_14: null,
        USERDEFINEDQUANTITY_15: null,
        USERDEFINEDQUANTITY_16: null,
        USERDEFINEDQUANTITY_17: null,
        USERDEFINEDQUANTITY_18: null,
        USERDEFINEDQUANTITY_19: null,
        USERDEFINEDQUANTITY_20: null,
        USERDEFINEDREFERENCE_11: null,
        USERDEFINEDREFERENCE_12: null,
        USERDEFINEDREFERENCE_13: null,
        USERDEFINEDREFERENCE_14: null,
        USERDEFINEDREFERENCE_15: null,
        USERDEFINEDREFERENCE_16: null,
        USERDEFINEDREFERENCE_17: null,
        USERDEFINEDREFERENCE_18: null,
        USERDEFINEDREFERENCE_19: null,
        USERDEFINEDREFERENCE_20: null,
        TOTALFREIGHTRATE: null,
        CREDITSTATUSREVIEW: null,
        CREDITREVIEWREASON: null,
        INVENTORYREVIEW: null,
        REVIEWER: null,
        REVIEWSTAGE: null,
        SETNO: null,
        HOLDATALTERNATEWH: null,
        CREATEORDERATALTERNATEWH: null,
        RECORD: null,
        CUSTOMERIDENTITYID: null,
        CUSTOMERNAME: null,
        CUSTOMERADDRESS1: null,
        CUSTOMERADDRESS2: null,
        CUSTOMERCITY: null,
        CUSTOMERZIP: null,
        CUSTOMERSTATE: null,
        CUSTOMERTELEPHONE1: null,
        CONTACTID: null,
        CONTACTNAME: null,
        DEPARTMENT: null,
        SHIPTOID: null,
        SHIPTONAME: null,
        PROFILECODE: null,
        RCAJOB: null,
        JOB: null,
        JOBDESCRIPTION: null,
        RSHIPVIA: null,
        SHIPVIA: null,
        BASISMETHOD: null,
        SALESPERSON1: null,
        SALESPERSON1NAME: null,
        SALESPERSON2: null,
        SALESPERSON2NAME: null,
        TAXCODE: null,
        TAXDESC1: null,
        TRANSCURRENCY: null,
        TRANSCURRENCYNAME: null,
        PAYCURRENCY: null,
        PAYCURRENCYNAME: null,
        CONSIGNEEFREIGHTZONECODE: null,
        TAXDESC2: null,
    };
    // Keeps how the listing was filtered while the user is away in the Add/Edit form - the search
    // panel criteria and the grid's own filtering - so Back lands on the same filtered listing
    // instead of an unfiltered one. Disabled in picker mode: the popup is transient and must not
    // share the full page's remembered state.
    const {
        formFields,
        setformFields,
        rememberSearch,
        forgetSearch,
        loadGridState,
        saveGridState,
    } = useSearchState({
        pageKey: SEARCH_STATE_PAGE_KEY,
        initialFormFields,
        layout: SearchLayout,
        detailPaths: SEARCH_STATE_DETAIL_PATHS,
        enabled: !props.pickerMode,
        gridRef: dataGrid,
        loadGridLayoutState: loadState,
        saveGridLayoutState: saveState,
        gridLayoutName: currentLayout,
    });

    const onSelectionChanged = ({ selectedRowsData }) => {
        const hasSingleSelection = selectedRowsData && selectedRowsData.length === 1;
        if (hasSingleSelection) {
            rowId.current = selectedRowsData[0].ROWID;
        }
        else {
            rowId.current = '';
        }
        if (props.onRecordSelected) {
            props.onRecordSelected(selectedRowsData[0]);
        }
        // Derived, not toggled: Edit needs exactly one row, and a toggle gets it wrong as soon as
        // the user moves from one row to another - it would disable the button with a row selected.
        setIsEditButtonDisabled(!hasSingleSelection);
    };

    const handelEditClick = () => {
        const buttonUrl = "/om/transactions/salesorders/edit-salesorder?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const combinePickerFilter = (baseFilter) => {
        const parts = [];
        if (baseFilter && baseFilter.length) parts.push(baseFilter);
        if (props.pickerFilter && props.pickerFilter.length) parts.push(props.pickerFilter);
        if (props.excludeRowId) parts.push(["R_ORIGINALTRANSACTION", "=", props.excludeRowId]);
        if (parts.length === 0) return null;
        if (parts.length === 1) return parts[0];
        const combined = [];
        parts.forEach((part, i) => {
            if (i > 0) combined.push("and");
            combined.push(part);
        });
        return combined;
    };

    const applySearch = (fields) => {
        let datasource = loadDatasource(fields);
        const { IDTYPE, ...filteredFormFields } = fields;
        const filters = buildDxFilters(filteredFormFields, SearchLayout, ['IsOpenStatus']);
        datasource.filter(combinePickerFilter(filters));
        setResultData(datasource);
    }

    const handleSearch = (e) => {
        e.event.stopPropagation();
        applySearch(formFields);
        rememberSearch(formFields);
    }
    const handleReset = (e) => {
        e.event.stopPropagation();
        // forgetSearch drops the remembered search and hands back the empty criteria, so the grid
        // is rebuilt from them without waiting for the state update to land.
        applySearch(forgetSearch());
    }
    useEffect(() => {
        // formFields already carries the search remembered from the previous visit, so this first
        // pass re-applies it - no extra fetch and no flash of unfiltered rows.
        applySearch(formFields);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.pickerFilter, props.excludeRowId]);

    const handleFormLoad = useCallback(() => {
                var stages = [
            { id: "L", text: "Canceled - No Inventory Effect" },
            { id: "Q", text: "Quote - No Inventory Effect" },
            { id: "P", text: "Plan - No Inventory Effect" },
            { id: "F", text: "Future - No Effect On Net Available" },
            { id: "N", text: "Pending - Effects Net Available" },
            { id: "A", text: "Assigned - Effect Available" },
            { id: "S", text: "Picked/Staged - Effect Available" },
            { id: "C", text: "Shipped/Completed - Effect Available" }
        ];
                var transactionTypes = [
            { id: "I", text: "Order/Invoice - Inventory Effect" },
            { id: "C", text: "Credit - Inventory Effect" },
            { id: "J", text: "$ Adjustment - No Inventory Effect - AR Credit" }];
          loadLookupFromStaticData(formRefs,"StatusFlag", TransactionStatuses,'key','value');
          loadLookupFromStaticData(formRefs, "StageFlag", stages,'id','text');
          loadLookupFromStaticData(formRefs, "TRANSACTIONTYPE", transactionTypes,'id','text');

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource,valueExpr='text',displayExpr='text') => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', valueExpr);
            formRefs.current[name].instance().option('displayExpr', displayExpr);
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);


    // fields defaults to the criteria on screen; callers pass them explicitly when the grid has to
    // be rebuilt from criteria the state has not caught up with yet (Reset).
    const loadDatasource = (fields = formFields) => {
        let store = createStore({
            key: 'ROWID',
            loadUrl: `${window._env_.REACT_APP_APIS}/om/Transaction/GetTransactions`,
            loadParams: {
                IsOpenStatus: props.pickerMode ? false : fields.IsOpenStatus,
                RestrictToActiveOrderStatuses: true,
            },
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        {/* <form style={{ width: "100%" }} onSubmit={(e) => onSearchTransaction(e)}> */}
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2
                                                }}
                                            >
                                                Enter Your Query For Sales Order Data Entry
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                    </Item>
                                </Toolbar>
                            )}
                            itemRender={(itemProps) => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='4D34F946-AD81-4C6C-876E-93BE7E9F6C74'
                                    layoutName='OMSalesOrderDataEntrySearchForm'
                                    defaultFormSchema={SearchLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                    noSpacingBeforeFirstRow={true}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />

                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={searchPanelStatus ? "GridHeightAccordianOpen" : "GridHeightAccordianClose"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode= {props.pickerMode? "single":"multiple"} />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadGridState}
                                storageKey={gridKey}
                                customSave={saveGridState}
                            />
                            <FilterRow visible={true} />
                            <Column dataType="string" dataField="RECORD" caption="Record #" />
                            <Column dataType="string" dataField="TRANSACTIONNUMBER" caption="Transaction #" />
                            <Column dataType="string" dataField="TRANSACTIONTYPE" caption="Type" />
                            <Column dataType="string" dataField="CUSTOMERIDENTITYID" caption="Customer" />
                            <Column dataType="string" dataField="CUSTOMERNAME" caption="Name" />
                            <Column dataType="string" dataField="FMTRIPNUMBER" caption="Trip Number" />
                            <Column dataType="string" dataField="SHIPTONAME" caption="Ship To Name" />
                            <Column dataType="string" dataField="PROFILECODE" caption="Profile" />
                            <Column visible={false} dataType="string" dataField="ROWID" caption="Row Id" />
                            <Column visible={false} dataType="number" dataField="KEYSEQUENCE" caption="Key Sequence" format={INTEGER_FORMAT} />
                            <Column dataType="datetime" dataField="CREATIONDATETIME" caption="Creation Date Time" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="CREATIONUSERID" caption="Creation User Id" />
                            <Column dataType="datetime" dataField="LASTUPDATEDATETIME" caption="Last Update Date Time" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="LASTUPDATEUSERID" caption="Last Update User Id" />
                            <Column visible={false} dataType="string" dataField="COMPANYID" caption="Company Id" />
                            <Column visible={false} dataType="string" dataField="MODULE" caption="Module" />
                            <Column visible={false} dataType="string" dataField="RECORDTYPE" caption="Record Type" />
                            <Column visible={false} dataType="datetime" dataField="TRANSACTIONDATE" caption="Transaction Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="INVOICEDATE" caption="Invoice Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="TRANSACTIONDUEDATE" caption="Transaction Due Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="PURCHASEORDERNUMBER" caption="Purchase Order Number" />
                            <Column visible={false} dataType="string" dataField="PRICELEVEL" caption="Price Level" />
                            <Column dataType="string" dataField="STATUS" caption="Status" />
                            <Column visible={false} dataType="string" dataField="PICKSTATUS" caption="Pick Status" />
                            <Column dataType="string" dataField="DISCOUNTTYPE" caption="Discount Type" />
                            <Column visible={false} dataType="string" dataField="ORDERSIGNEDFLAG" caption="Order Signed Flag" />
                            <Column visible={false} dataType="string" dataField="REFERENCE" caption="Reference" />
                            <Column visible={false} dataType="string" dataField="COMMENT" caption="Comment" />
                            <Column visible={false} dataType="datetime" dataField="SHIPPINGDATE" caption="Shipping Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="SHIPPERCOMMENT" caption="Shipper Comment" />
                            <Column visible={false} dataType="string" dataField="TRUCKREFERENCE" caption="Truck Reference" />
                            <Column visible={false} dataType="datetime" dataField="TRUCKARRIVALDATETIME" caption="Truck Arrival Date Time" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="TRUCKDEPARTDATETIME" caption="Truck Depart Date Time" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="TRUCKCOMMENT" caption="Truck Comment" />
                            <Column visible={false} dataType="string" dataField="PRINTINVOICE" caption="Print Invoice" />
                            <Column visible={false} dataType="string" dataField="PRINTBOL" caption="Print BOL" />
                            <Column visible={false} dataType="string" dataField="PRINTDELIVERYNOTIFICATION" caption="Print Delivery Notification" />
                            <Column visible={false} dataType="string" dataField="PRINTORDERACKNOWLEDGEMENT" caption="Print Order Acknowledgement" />
                            <Column visible={false} dataType="string" dataField="SENDFAX" caption="Send Fax" />
                            <Column visible={false} dataType="string" dataField="SENDEMAIL" caption="Send Email" />
                            <Column visible={false} dataType="datetime" dataField="CANCELDATE" caption="Cancel Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="CANCELCOMMENT" caption="Cancel Comment" />
                            <Column visible={false} dataType="string" dataField="INVENTOTYAVAILABILITYSTATUS" caption="Inventory Availability Status" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_1" caption="User Defined Code 1" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_2" caption="User Defined Code 2" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_3" caption="User Defined Code 3" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_4" caption="User Defined Code 4" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_5" caption="User Defined Code 5" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_6" caption="User Defined Code 6" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_7" caption="User Defined Code 7" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_8" caption="User Defined Code 8" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_9" caption="User Defined Code 9" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_10" caption="User Defined Code 10" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_1" caption="User Defined Reference 1" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_2" caption="User Defined Reference 2" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_3" caption="User Defined Reference 3" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_4" caption="User Defined Reference 4" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_5" caption="User Defined Reference 5" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_6" caption="User Defined Reference 6" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_7" caption="User Defined Reference 7" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_8" caption="User Defined Reference 8" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_9" caption="User Defined Reference 9" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_10" caption="User Defined Reference 10" />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_1" caption="User Defined Date 1" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_2" caption="User Defined Date 2" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_3" caption="User Defined Date 3" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_4" caption="User Defined Date 4" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_5" caption="User Defined Date 5" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_6" caption="User Defined Date 6" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_7" caption="User Defined Date 7" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_8" caption="User Defined Date 8" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_9" caption="User Defined Date 9" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_10" caption="User Defined Date 10" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_1" caption="User Defined Quantity 1" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_2" caption="User Defined Quantity 2" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_3" caption="User Defined Quantity 3" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_4" caption="User Defined Quantity 4" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_5" caption="User Defined Quantity 5" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_6" caption="User Defined Quantity 6" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_7" caption="User Defined Quantity 7" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_8" caption="User Defined Quantity 8" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_9" caption="User Defined Quantity 9" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_10" caption="User Defined Quantity 10" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCOMMENT" caption="User Defined Comment" />
                            <Column visible={false} dataType="number" dataField="DISCOUNTPERCENT" caption="Discount Percent" format={DECIMAL_FORMAT} />
                            <Column visible={false} dataType="string" dataField="PARTIALSHIPMENT" caption="Partial Shipment" />
                            <Column visible={false} dataType="datetime" dataField="CREDITREVIEWDATE" caption="Credit Review Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="CREDITREVIEWCOMMENT" caption="Credit Review Comment" />
                            <Column visible={false} dataType="string" dataField="SALESMETHOD" caption="Sales Method" />
                            <Column visible={false} dataType="string" dataField="REASONCODE" caption="Reason Code" />
                            <Column visible={false} dataType="number" dataField="FISCALPERIOD" caption="Fiscal Period" format={INTEGER_FORMAT} />
                            <Column visible={false} dataType="number" dataField="FISCALYEAR" caption="Fiscal Year" format={INTEGER_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="COMMITDATE" caption="Commit Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="SALESCOMMISIONADVANCE" caption="Sales Commission Advance" />
                            <Column visible={false} dataType="string" dataField="PRINTPICKINGSLIP" caption="Print Picking Slip" />
                            <Column visible={false} dataType="string" dataField="PRINTPACKINGSLIP" caption="Print Packing Slip" />
                            <Column visible={false} dataType="number" dataField="FMPUSTOPNUMBER" caption="FM PU Stop Number" format={INTEGER_FORMAT} />
                            <Column visible={false} dataType="string" dataField="COMMISSIONTYPE" caption="Commission Type" />
                            <Column visible={false} dataType="string" dataField="COMMISSIONTRANSACTIONPAYGROUP" caption="Commission Transaction Pay Group" />
                            <Column visible={false} dataType="string" dataField="COMMISSIONSETTLEMENTGROUP" caption="Commission Settlement Group" />
                            <Column visible={false} dataType="string" dataField="FMTRANSFERFLAG" caption="FM Transfer Flag" />
                            <Column visible={false} dataType="string" dataField="CURRENCYBASIS" caption="Currency Basis" />
                            <Column visible={false} dataType="number" dataField="CURRENCYCONVERSIONFACTOR" caption="Currency Conversion Factor" format={RATE_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="CURRENCYCONVERSIONDATE" caption="Currency Conversion Date" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="string" dataField="STAGE" caption="Stage" />
                            <Column visible={false} dataType="string" dataField="BACKORDERFLAG" caption="Backorder Flag" />
                            <Column visible={false} dataType="string" dataField="TRANSACTIONSUBTYPE" caption="Transaction Subtype" />
                            <Column visible={false} dataType="string" dataField="EDITRANSMITFLAG" caption="EDI Transmit Flag" />
                            <Column visible={false} dataType="string" dataField="TRANSACTIONORIGIN" caption="Transaction Origin" />
                            <Column visible={false} dataType="string" dataField="COMMITTYPE" caption="Commit Type" />
                            <Column visible={false} dataType="number" dataField="CURRENCYRATE" caption="Currency Rate" format={RATE_FORMAT} />
                            <Column visible={false} dataType="string" dataField="TRANSCURRENCYTYPE" caption="Trans Currency Type" />
                            <Column visible={false} dataType="string" dataField="PAYCURRENCYTYPE" caption="Pay Currency Type" />
                            <Column visible={false} dataType="string" dataField="RATETIMING" caption="Rate Timing" />
                            <Column visible={false} dataType="string" dataField="FMTRUCKREFERENCE" caption="FM Truck Reference" />
                            <Column visible={false} dataType="string" dataField="FMDRIVERREFERENCE" caption="FM Driver Reference" />
                            <Column visible={false} dataType="string" dataField="FMTRAILERREFERENCE" caption="FM Trailer Reference" />
                            <Column visible={false} dataType="string" dataField="IMPORTFILENAME" caption="Import File Name" />
                            <Column visible={false} dataType="number" dataField="DEFAULTDETAILDISCOUNT" caption="Default Detail Discount" format={DECIMAL_FORMAT} />
                            <Column visible={false} dataType="string" dataField="CONSIGNMENT" caption="Consignment" />
                            <Column visible={false} dataType="string" dataField="EQUIPMENT" caption="Equipment" />
                            <Column visible={false} dataType="number" dataField="DEFAULTFREIGHTRATE" caption="Default Freight Rate" format={RATE_FORMAT} />
                            <Column visible={false} dataType="string" dataField="MISCFEETYPE" caption="Misc Fee Type" />
                            <Column visible={false} dataType="string" dataField="CHARGEANDHOLDTYPE" caption="Charge And Hold Type" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_11" caption="User Defined Code 11" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_12" caption="User Defined Code 12" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_13" caption="User Defined Code 13" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_14" caption="User Defined Code 14" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_15" caption="User Defined Code 15" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_16" caption="User Defined Code 16" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_17" caption="User Defined Code 17" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_18" caption="User Defined Code 18" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_19" caption="User Defined Code 19" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDCODE_20" caption="User Defined Code 20" />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_11" caption="User Defined Date 11" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_12" caption="User Defined Date 12" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_13" caption="User Defined Date 13" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_14" caption="User Defined Date 14" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_15" caption="User Defined Date 15" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_16" caption="User Defined Date 16" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_17" caption="User Defined Date 17" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_18" caption="User Defined Date 18" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_19" caption="User Defined Date 19" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="datetime" dataField="USERDEFINEDDATE_20" caption="User Defined Date 20" format={DATETIME_FORMAT} />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_11" caption="User Defined Quantity 11" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_12" caption="User Defined Quantity 12" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_13" caption="User Defined Quantity 13" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_14" caption="User Defined Quantity 14" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_15" caption="User Defined Quantity 15" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_16" caption="User Defined Quantity 16" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_17" caption="User Defined Quantity 17" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_18" caption="User Defined Quantity 18" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_19" caption="User Defined Quantity 19" />
                            <Column visible={false} dataType="number" format={DECIMAL_FORMAT} dataField="USERDEFINEDQUANTITY_20" caption="User Defined Quantity 20" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_11" caption="User Defined Reference 11" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_12" caption="User Defined Reference 12" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_13" caption="User Defined Reference 13" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_14" caption="User Defined Reference 14" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_15" caption="User Defined Reference 15" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_16" caption="User Defined Reference 16" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_17" caption="User Defined Reference 17" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_18" caption="User Defined Reference 18" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_19" caption="User Defined Reference 19" />
                            <Column visible={false} dataType="string" dataField="USERDEFINEDREFERENCE_20" caption="User Defined Reference 20" />
                            <Column visible={false} dataType="number" dataField="TOTALFREIGHTRATE" caption="Total Freight Rate" format={RATE_FORMAT} />
                            <Column visible={false} dataType="string" dataField="CREDITSTATUSREVIEW" caption="Credit Status Review" />
                            <Column visible={false} dataType="string" dataField="CREDITREVIEWREASON" caption="Credit Review Reason" />
                            <Column visible={false} dataType="string" dataField="INVENTORYREVIEW" caption="Inventory Review" />
                            <Column visible={false} dataType="string" dataField="REVIEWER" caption="Reviewer" />
                            <Column visible={false} dataType="string" dataField="REVIEWSTAGE" caption="Review Stage" />
                            <Column visible={false} dataType="string" dataField="SETNO" caption="Set No" />
                            <Column visible={false} dataType="string" dataField="HOLDATALTERNATEWH" caption="Hold At Alternate WH" />
                            <Column visible={false} dataType="string" dataField="CREATEORDERATALTERNATEWH" caption="Create Order At Alternate WH" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERADDRESS1" caption="Address1" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERADDRESS2" caption="Address2" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERCITY" caption="City" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERZIP" caption="Zip" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERSTATE" caption="State" />
                            <Column visible={false} dataType="string" dataField="CUSTOMERTELEPHONE1" caption="Telephone1" />
                            <Column visible={false} dataType="string" dataField="CONTACTID" caption="Contact Id" />
                            <Column visible={false} dataType="string" dataField="CONTACTNAME" caption="Contact Name" />
                            <Column visible={false} dataType="string" dataField="DEPARTMENT" caption="Department" />
                            <Column visible={false} dataType="string" dataField="SHIPTOID" caption="Ship To Id" />
                            <Column visible={false} dataType="string" dataField="RCAJOB" caption="RCA Job" />
                            <Column visible={false} dataType="string" dataField="JOB" caption="Job" />
                            <Column visible={false} dataType="string" dataField="JOBDESCRIPTION" caption="Job Description" />
                            <Column visible={false} dataType="string" dataField="RSHIPVIA" caption="R Ship Via" />
                            <Column visible={false} dataType="string" dataField="SHIPVIA" caption="Ship Via" />
                            <Column visible={false} dataType="string" dataField="BASISMETHOD" caption="Basis Method" />
                            <Column visible={false} dataType="string" dataField="SALESPERSON1" caption="Salesperson1" />
                            <Column visible={false} dataType="string" dataField="SALESPERSON1NAME" caption="Salesperson1 Name" />
                            <Column visible={false} dataType="string" dataField="SALESPERSON2" caption="Salesperson2" />
                            <Column visible={false} dataType="string" dataField="SALESPERSON2NAME" caption="Salesperson2 Name" />
                            <Column visible={false} dataType="string" dataField="TAXCODE" caption="Tax Code" />
                            <Column visible={false} dataType="string" dataField="TAXDESC1" caption="Tax Description1" />
                            <Column visible={false} dataType="string" dataField="TRANSCURRENCY" caption="Trans Currency" />
                            <Column visible={false} dataType="string" dataField="TRANSCURRENCYNAME" caption="Trans Currency Name" />
                            <Column visible={false} dataType="string" dataField="PAYCURRENCY" caption="Pay Currency" />
                            <Column visible={false} dataType="string" dataField="PAYCURRENCYNAME" caption="Pay Currency Name" />
                            <Column visible={false} dataType="string" dataField="CONSIGNEEFREIGHTZONECODE" caption="Consignee Freight Zone Code" />
                            <Column visible={false} dataType="string" dataField="TAXDESC2" caption="Tax Description2" />

                            <GridToolbar>
                                {
                                    props.pickerMode ? 
                                    <>
                                    <GridToolbarItem location="before">
                                                <Button
                                                    onClick={()=>props.onRecordSelected(rowId.current)}
                                                    type="default"
                                                    text="Ok"
                                                ></Button>
                                            </GridToolbarItem>
                                    </>: (
                                        <>
                                            <GridToolbarItem location="before">
                                                <Button
                                                    disabled={isEditButtonDisabled}
                                                    onClick={handelEditClick}
                                                    type="default"
                                                    text="Edit"
                                                ></Button>
                                            </GridToolbarItem>
                                            <GridToolbarItem location="before">
                                                <div>
                                                    <Link to="/om/transactions/salesorders/add-salesorder">
                                                        <Button
                                                            type="default"
                                                            className="gridTopButton"
                                                            text="Create"
                                                        ></Button>
                                                    </Link>
                                                </div>
                                            </GridToolbarItem>
                                        </>
                                    )
                                }

                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);